import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import { IPdflink } from "../../types/interfaces";
import { getNationality } from "../../services/misc";

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

const MyDocument: any = Document
const MyPage: any = Page

const VenteDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid';
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 15
    },
    middleLogoContainer1: {
      flex: 5
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    clientTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 20
    },
    clientTitleView1: {
      width: "100%"
    },
    clientTitleView2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      marginVertical: 6,
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans',
      textAlign: "center",
      fontSize: 22,
      backgroundColor: "#fefefe",
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    table: { 
      // display: "table", 
      width: "auto", 
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderRightWidth: 0, 
      borderBottomWidth: 0,
      marginBottom: 15
    },
    tableRow: { 
      margin: "auto", 
      flexDirection: "row" 
    },
    // footerRow: { 
    //   marginLeft: COL1_WIDTH + '%', 
    //   flexDirection: "row" 
    // },
    headerCol: { 
      backgroundColor: "#62af42",
      color: "white",
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderBottomColor: 'green',
      borderWidth: 1,
      fontWeight: 600,
      textAlign: "center"
    },
    rowCol: { 
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      textAlign: "center",
      fontFamily: 'Open Sans',
      fontWeight: 300,
      // borderLeftWidth: 0,
      // borderTopWidth: 0 
    },
    footerCol: {
      backgroundColor: "#62af42",
      color: "white",
      fontWeight: 600
    },
    cellText: { 
      marginVertical: 5,
      // marginHorizontal: 2,
      textAlign: "center",
      fontSize: 9
    },
    headerText: {
      fontWeight: 600
    },
    logo: {
      height: "auto",
      flex: 1
    },
    dateFournisseurView: {
      color: "#555555",
      fontSize: 12,
      // width: "100%",
      fontFamily: 'Open Sans',
      justifyContent: "flex-end",
      flexDirection: "row",
      marginBottom: 10
    },
    titlesView: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginTop: 7,
      marginBottom: 7
    },
    cardContainer1: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    cardContainer2: {
      // display: "table",
      width: "100%"
    },
    clientCardContainer: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      fontFamily: 'Open Sans',
      color: "#000000",
      fontSize: 11,
    },
    cardRow: {
      width: "100%",
      flexDirection: "row",
      // marginBottom: 4,
      marginVertical: 0,
      paddingVertical: 0,
    },
    cardCellTitle: {
      fontStyle: "italic",
      width: "20%"
    },
    cardCellValue: {
      fontWeight: 600,
      width: "20%"
    },
    cardCellSpace: {
      width: "20%"
    },
    clientCardCellTitle: {
      fontWeight: 600,
      borderRightWidth: 2,
      borderRightColor: "green",
      borderRightStyle: "solid",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#f2f2f2",
      flex: 1
    },
    clientCardCellValue: {
      fontStyle: "italic",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#fefefe",
      flex: 1
    },
    arreteView: {
      color: "#333333",
      fontSize: 10,
      fontStyle: "italic",
      fontFamily: 'Open Sans',
      width: "100%",
      marginTop: 20
    },
    directionText: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      marginLeft: "70%",
      marginTop: 25
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 14,
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    }
  });
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        {/* <Text>{fileObject && fileObject.toUpperCase()}</Text> */}
        <Text>{""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      <View fixed>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={{...styles.middleLogoText, ...(data.PROJET ? styles.middleLogoTextTop : {paddingVertical: 10})}}>
                SHEMS AL MADINA
              </Text>
              {data.PROJET ? <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                {data.PROJET.toUpperCase()}
              </Text> : null}
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>
      
      <View style={styles.logoContainer}>
        <View style={styles.clientTitleView1}>
          <View style={styles.clientTitleView2}>
            <Text>
              Fiche Client
            </Text>
          </View>
        </View>
      </View>
      
      <View style={{...styles.clientCardContainer, ...styles.lastElement}}>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>{(data.PASSPORT && data.CIN) || !data.PASSPORT ? "CIN" : "Passeport"}</Text>
          <Text style={styles.clientCardCellValue}>{(data.PASSPORT && data.CIN) || !data.PASSPORT ? (data.CIN || "-") : data.PASSPORT || "-"}</Text>
        </View>
        {data.PASSPORT && data.CIN ? <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Passeport</Text>
          <Text style={styles.clientCardCellValue}>{data.PASSPORT}</Text>
        </View> : null}
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Nom &amp; Prénom</Text>
          <Text style={styles.clientCardCellValue}>{`${data.NOM || "-"} ${data.PRENOM || ""}`}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Commercial</Text>
          <Text style={styles.clientCardCellValue}>{data.user?.LOGIN || data.COMMERCIAL || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Adresse</Text>
          <Text style={styles.clientCardCellValue}>{data.ADRESSE || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Ville</Text>
          <Text style={styles.clientCardCellValue}>{data.VILLE || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Pays</Text>
          <Text style={styles.clientCardCellValue}>{data.PAYS || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Nationalité</Text>
          <Text style={styles.clientCardCellValue}>{getNationality(data.NATIONALITE)}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Date et lieu de naissance</Text>
          <Text style={styles.clientCardCellValue}>{data.DATE_NAISS || data.LIEU_NAISS ? `${data.DATE_NAISS ? `le ${moment(data.DATE_NAISS).format('DD/MM/YYYY')}` : ""}${data.LIEU_NAISS ? ` à ${data.LIEU_NAISS}` : ""}` : "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Situation familiale / enfants</Text>
          <Text style={styles.clientCardCellValue}>{`${data.SITUATION_FAM || "-"} ${data.NBR_ENFANT || data.NBR_ENFANT === 0 ? ` / ${data.NBR_ENFANT} enfants` : "-"}`}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Fonction</Text>
          <Text style={styles.clientCardCellValue}>{data.PROFESSION || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Numéro(s) de Téléphone</Text>
          <Text style={styles.clientCardCellValue}>{`${data.TEL.length >= 4 && data.TEL[0] !== "0" ? ("+" + data.TEL) : data.TEL}${data.TEL2 ? (data.TEL2.length >= 4 && data.TEL2[0] !== "0" ? (" / +" + data.TEL2) : (" / " + data.TEL2)) : ""}`}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Email</Text>
          <Text style={styles.clientCardCellValue}>{data.MAIL || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Support publicitaire</Text>
          <Text style={styles.clientCardCellValue}>{data.SUPPORT_PUB || "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Date Visite</Text>
          <Text style={styles.clientCardCellValue}>{data.DATE_VISITE ? moment(data.DATE_VISITE).format('DD/MM/YYYY') : "-"}</Text>
        </View>
        <View style={styles.cardRow}>
          <Text style={styles.clientCardCellTitle}>Observation</Text>
          <Text style={styles.clientCardCellValue}>{data.OBSERVATION || "-"}</Text>
        </View>
      </View>

      <View style={styles.pageCountContainer} fixed>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
        {/* <Text>{data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? "* Demande de remise pas encore validée par l'administration." : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? "* Demande de remise refusée par l'administration." : " "}</Text> */}
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default VenteDocument;
